import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { ProductDetailInfoAddToCart } from './product-detail-info-add-to-cart';
import { ProductDetailInfoAlergens } from './product-detail-info-alergens';
import { ProductDetailInfoCoupon } from './product-detail-info-coupon';
import { ProductDetailInfoDescription } from './product-detail-info-description';
import { ProductDetailInfoEnergyValuesTable } from './product-detail-info-energy-values-table';
import { ProductDetailInfoName } from './product-detail-info-name';
import { ProductDetailInfoPackaging } from './product-detail-info-packaging';
import { ProductDetailInfoPrice } from './product-detail-info-price';
import { ProductDetailInfoShowMore } from './product-detail-info-show-more';
import { ProductDetailInfoVariantSelect } from './product-detail-info-variant-select';
import { ProductDetailTags } from './product-detail-tags';
import './product-detail.scss';

type Props = ComponentPropsWithoutRef<'div'>;
const ProductDetailInfoWrapper = ({ children, className, ...props }: Props) => {
    return (
        <div className={cn('product-detail__info', className)} {...props}>
            <ProductDetailTags />
            {children}
        </div>
    );
};

export const ProductDetailInfo = Object.assign(ProductDetailInfoWrapper, {
    Tags: ProductDetailTags,
    AddToCart: ProductDetailInfoAddToCart,
    Coupon: ProductDetailInfoCoupon,
    Packaging: ProductDetailInfoPackaging,
    Alergens: ProductDetailInfoAlergens,
    EnergyValuesTable: ProductDetailInfoEnergyValuesTable,
    ShowMore: ProductDetailInfoShowMore,
    Name: ProductDetailInfoName,
    Description: ProductDetailInfoDescription,
    VariantSelect: ProductDetailInfoVariantSelect,
    Price: ProductDetailInfoPrice,
});
